import React, { FC, useState, useEffect } from 'react'
import * as StyledCategoryPage from './categoryPage.styles'
import StandardHero from 'components/hero/standardHero'
import ProductList from 'components/products/productList'
import StorefrontCategory from '@local-types/categories/storefrontCategory'
import ProductCategoryPage from 'interfaces/prismic/productCategory'
import { PageContainer, Columns, Column } from 'components/base/grid/grid'
import useProductsByCategoryId from 'hooks/useProductsByCategoryId'
import ErrorMessage from 'components/errorMessage'
import VisibilitySensor from 'react-visibility-sensor'
import { useActiveCompany } from 'hooks/useActiveCompany/useActiveCompany'
// @ts-ignore
import { RichText } from 'prismic-reactjs'
import { H1 } from 'components/base/typography/headings'
import { RichTextStyleWrapper } from 'components/base/typography/richTextStyleWrapper'
import { Block } from 'components/base/sections/section'

interface Props {
	category: StorefrontCategory | null
	categoryPage: ProductCategoryPage | null
}

const CategoryPage: FC<Props> = ({ category, categoryPage }) => {
	const [page, setPage] = useState(1)
	const { activeRelation } = useActiveCompany()
	const { products, loading, lazyLoading, error, totalRecords } = useProductsByCategoryId(category?.id || '', page)
	const isLastPage = products.length >= totalRecords

	useEffect(() => {
		if (page > 1) {
			setPage(1)
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			})
		}
	}, [activeRelation])

	const onVisibilitySensorChange = (isVisible: boolean) => {
		if (isVisible && !isLastPage && !lazyLoading && !loading) {
			setPage(page + 1)
		}
	}

	if (error)
		return (
			<ErrorMessage
				title="Tókst ekki að sækja vöruflokk"
				text="Vinsamlegast reynið aftur síðar eða hafið samband við þjónustu"
			/>
		)

	return (
		<>
			<StandardHero
				title={category?.name || ''}
				image={categoryPage !== null ? categoryPage.data.hero_image : '/images/veggie-bbq.webp'}
				imageOnMobile
				showHeroTitle={categoryPage?.data.show_category_name ?? true}
			/>
			<StyledCategoryPage.Wrapper>
				<PageContainer>
					{categoryPage?.data.title && categoryPage?.data.content && (
						<StyledCategoryPage.ContentWrapper>
							<Columns>
								<Column desktopSmall={1 / 3} desktopLarge={1 / 4}>
									<H1 mb="1.5rem">{RichText.asText(categoryPage.data.title)}</H1>
								</Column>
								<Column desktopSmall={2 / 3} desktopLarge={7 / 12}>
									<RichTextStyleWrapper>{RichText.render(categoryPage.data.content)}</RichTextStyleWrapper>
								</Column>
							</Columns>
						</StyledCategoryPage.ContentWrapper>
					)}
					<ProductList products={products} loading={loading} error={error} empty={products.length === 0 && !loading} />
					<VisibilitySensor active={products.length > 0 && !isLastPage && !error} onChange={onVisibilitySensorChange}>
						<div style={{ width: '1px', height: '1px' }}></div>
					</VisibilitySensor>
				</PageContainer>
			</StyledCategoryPage.Wrapper>
		</>
	)
}

export default CategoryPage
